import { ref } from 'vue';

// eslint-disable-next-line import/prefer-default-export
export function useLoading() {
  const isLoading = ref<boolean>(false);

  const startLoading = (): void => {
    isLoading.value = true;
  };

  const stopLoading = (): void => {
    isLoading.value = false;
  };

  return {
    isLoading,
    startLoading,
    stopLoading,
  };
}
